module.exports = __webpack_public_path__ + "d6bda5ee1a211198f5acfc5b2be9b880.svg";